module.exports = __webpack_public_path__ + "img/arrow-circle-right-red.1cf5dd93.svg";